import Vue from 'vue';
import {mapGetters} from 'vuex';

import Alert from '../components/alert.vue';

export default {
  name: 'MixinAlert',
  computed: {
    ...mapGetters([
      'testLevel'
    ])
  },
  methods: {
    /**
     * Display a message in the header to inform the user
     * that a test level is set in URL
     */
    showTestAlert() {
      if (!this.testLevel) {
        return;
      }

      const ComponentClass = Vue.extend(Alert);
      const instance = new ComponentClass({
        propsData: {
          className: 'test-level-container',
          top: '0'
        }
      });

      instance.$slots.default = [this.$t('all.testEnabled') + this.testLevel];
      instance.$mount();
      document.body.append(instance.$el);
    },
    /**
     * Display a message in the header to inform the user
     * that preview mode is true
     */
    showPreviewAlert() {
      const ComponentClass = Vue.extend(Alert);
      const instance = new ComponentClass({
        propsData: {
          className: 'test-level-container',
          top: '0'
        }
      });

      instance.$slots.default = this.$t('all.previewEnable');
      instance.$mount();
      document.body.append(instance.$el);
    },
    /**
     * Display a message in the header to inform the user
     * that an issue happened during the payment validation
     */
    showPaymentErrorAlert(message) {
      const ComponentClass = Vue.extend(Alert);

      let top = '0';
      if (document.querySelectorAll('.test-level-container').length > 0) {
        top = '50px';
      }

      const instance = new ComponentClass({
        propsData: {
          className: 'ogone-message-container',
          top
        }
      });

      instance.$slots.default = [message];
      instance.$mount();
      document.body.append(instance.$el);
    }
  }
};



// WEBPACK FOOTER //
// ./src/common/mixins/alert.js